<mat-selection-list [multiple]="false" #cards>
    @if (creditCards?.items?.length) {
        @for (card of creditCards?.items; track $index) {
            <app-credit-cards-list-option
                [loading]="loading"
                [creditCardItem]="card"
                class="w-100"
                (eventOnSelectCreditCard)="selectCreditCard($event)"
                [aboveThreshold]="aboveThreshold"
            />
        }
    } @else {
        @if (displayEmptyList) {
            <app-empty-card-list />
        }
    }
</mat-selection-list>
